import { saveAs } from "file-saver";
import { IPaymentSession } from "src/types/types";
import { PDF, PDFProps } from "./pdf/PDF";
import { ReportPDF, ReportPDFProps } from "./pdf/ReportPDF";
import { SummaryPDF, SummaryPDFProps } from "./pdf/SummaryPDF";
import { pdf } from "@react-pdf/renderer";
import { createElement } from "react";
import Decimal from "decimal.js";

//!TODO: check if need here ot need to remove or move to main tools;
//!TODO: store and cache calculated values
//!TODO: need more light and smart version of this functon;
export const monthsForLocale = (
	localeName = window.navigator.language ?? "en-US",
	monthIndex: number,
	year: number,
	monthFormat: "long" | "numeric" | "2-digit" | "short" | "narrow" | undefined = "long",
) => {
	const format = new Intl.DateTimeFormat(localeName, { month: monthFormat }).format;
	return [...Array(12).keys()].map(_m => format(new Date(Date.UTC(year, monthIndex % 12))))[0];
};

export const randomSHA256 = async () => {
	const val = new Date().getTime().toString();
	const res = await hashValue(val);
	return res;
};

export const hashValue = async (val: string) =>
	crypto.subtle.digest("SHA-256", new TextEncoder().encode(val)).then(h => {
		const hexes = [],
			view = new DataView(h);
		for (let i = 0; i < view.byteLength; i += 4) hexes.push(("00000000" + view.getUint32(i).toString(16)).slice(-8));
		return hexes.join("");
	});

export const savePdf = async (session: IPaymentSession) => {
	const blob = await renderPDF({ session: session });
	saveAs(blob, `payment_${session.id}.pdf`);
};

export const saveReportPdf = async (props: ReportPDFProps) => {
	const blob = await renderReportPDF(props);
	const client = props.client;
	saveAs(blob, `report_${client.id}_${props.date}.pdf`);
};

export const saveSummaryPdf = async (props: SummaryPDFProps) => {
	const blob = await renderSummaryPDF(props);
	saveAs(blob, `summary_${props.periodFrom}_${props.periodTo}.pdf`);
};

export const renderPDF = async (props: PDFProps) => {
	const element = createElement(PDF, { session: props.session });
	return pdf(element as any).toBlob();
};

export const renderSummaryPDF = async (props: SummaryPDFProps) => {
	const element = createElement(SummaryPDF, props);
	return pdf(element as any).toBlob();
};

export const renderReportPDF = async (props: ReportPDFProps) => {
	const element = createElement(ReportPDF, props);
	return pdf(element as any).toBlob();
};

export const formatAmount = (val?: number): string => {
	const decimals = String(val).split(".")[1]?.length ?? 0;
	return decimals < 2 ? (val?.toFixed(2) ?? "0.00") : String(val);
};

export const cents = (val: string | number | null | undefined): string => {
	try {
		const res = new Decimal(val ?? 0).div(100).toFixed(2);
		return res;
	} catch (e) {
		console.error("Error converting cents:", e);
		return val?.toString() ?? "0";
	}
};
